const languages = ['en', 'cn', 'ru', 'es', 'sa', 'pt'];
const objectId = value => typeof value === 'string' && /^[a-f\d]{24}$/i.test(value);
const uuid = value => typeof value === 'string' && /^[a-f\d]{8}-[a-f\d]{4}-[1-5][a-f\d]{3}-[89ab][a-f\d]{3}-[a-f\d]{12}$/i.test(value);

// URLs identify a saved generation, never contain generated content, and never
// invoke publication. The destination is the ordinary medicine Add/Edit form.
export function seoReviewEditorPath(workspace, { adminBase = '', preferredLanguage } = {}) {
  const generation = workspace?.contentGeneration;
  if (!uuid(workspace?.id) || !uuid(generation?.requestId)) throw new Error('A saved medicine generation is required before opening its editor.');
  const linked = workspace.linkedEntries || {};
  const existing = workspace.mode === 'existing' || (!workspace.mode && Boolean(workspace.sourceId));
  const requested = Array.isArray(generation.languages) ? generation.languages.filter(code => languages.includes(code)) : [];
  let language = languages.includes(preferredLanguage) ? preferredLanguage : requested.includes('en') ? 'en' : requested[0] || 'en';
  // The current database links translated medicines to their English record.
  // A brand-new family is reviewed in English first; no hidden anchor is saved
  // merely because the user generated or opened a non-English draft.
  if (!existing && !objectId(linked.en)) language = 'en';
  const query = new URLSearchParams({ seoWorkspace: workspace.id, seoGeneration: generation.requestId, seoReview: '1' });
  const id = linked[language];
  const base = `${String(adminBase).replace(/\/+$/, '')}/medicines/${language}`;
  if (objectId(id)) return `${base}/${id}/edit?${query}`;
  const englishId = linked.en || (workspace.sourceLanguage === 'en' ? workspace.sourceId : null);
  if (language !== 'en' && objectId(englishId)) query.set('source', englishId);
  return `${base}/new?${query}`;
}
